import { render, staticRenderFns } from "./EditarConfiguracaoTarjaCronometro.vue?vue&type=template&id=62ed8037&scoped=true"
import script from "./EditarConfiguracaoTarjaCronometro.vue?vue&type=script&lang=js"
export * from "./EditarConfiguracaoTarjaCronometro.vue?vue&type=script&lang=js"
import style0 from "./EditarConfiguracaoTarjaCronometro.vue?vue&type=style&index=0&id=62ed8037&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ed8037",
  null
  
)

export default component.exports